module.exports = __webpack_public_path__ + "media/illustrations/Login_Illustration-e3d10b7d.png";